import BillingHTTP from 'utils/billing-http';

class BillingService {
  updateConfigured(billingId) {
    return BillingHTTP.putContent(`/dashboard-api/v2/billings/${billingId}`, {
      configured: true,
    });
  }

  changeDueDay(billingId, dueDay) {
    return BillingHTTP.putContent(`/dashboard-api/v2/billings/${billingId}/change-due-day`, {
      due_day: parseInt(dueDay, 10),
    });
  }
}

export default new BillingService();
